<template>

  <section class="home-head" :class="{ 'scrolled': isScrolled,'another-class': isRouterIndex == '1' }">

    <section class="home-header">
      <div class="home-header__logo">
        <img src="../../../assets/homeNew/logo.png" />
      </div>
      <!-- 搜索 -->
      <div class="home-header__quick">
        <div class="home-header__quick__search">
          <el-input type="text" v-model="input" placeholder="搜索应用服务" @keyup.enter.native="search"></el-input>
          <img src="../../../assets/homeNew/search.png" @click="search" class="home-header__quick__search__icon" />
        </div>
        <!-- 点击事件 -->
        <div class="home-header__quick__nav">
          <div class="home-header__quick__nav__item" @click="titleChange('home',0)">
            <img src="../../../assets/homeNew/home.png" />
            <span>首页</span>
          </div>
          <div class="home-header__quick__nav__item" @click="goNewList">
            <img src="../../../assets/homeNew/gw.png" />
            <span>官网</span>
          </div>
          <div class="home-header__quick__nav__item" @click="titleChangeWen('serviceList',0)">
            <img src="../../../assets/homeNew/notice.png" />
            <span>消息</span>
          </div>

          <div class="home-header__quick__nav__item" @click="titleChangeWen('feedback',0)">
            <img src="../../../assets/homeNew/question.png" />
            <span>问题</span>
          </div>
          <!-- <div style="position: relative;">
            <div class="home-header__quick__nav__item" @click="goHomeWen()">
              <img src="../../../assets/homeNew/question.png" />
              <span>问题</span>
            </div>
            <div class="dropdown" v-show="showTableWen" style="left: -8px;">
              <ul class="dropdown-content">
                <li class="menu-item" :class="tablesIndexWen == index ? 'selected' : ''" @click="titleChangeWen(item.value,index)" v-for="(item, index) in urlDataWen" :key="index">{{ item.name }}</li>
                <div class="arrow"></div>
              </ul>
            </div>
          </div> -->

        </div>
        <!-- 个人信息 -->
        <div style="position: relative;">

          <div class="home-header__quick__user" @click="goHome()" style="cursor: pointer;">
            <img v-if="userInfo.logo == ''" src="../../..//assets/homeNew/default-header.png" class="home-header__quick__user__avatar" />
            <img v-if="userInfo.logo != ''" :src="userInfo.logo" class="home-header__quick__user__avatar" />
            <span class="home-header__quick__user__name">{{ userInfo.userName }}</span>
            <img src="../../../assets/homeNew/arrow-down.png" class="home-header__quick__user__arrow" />
          </div>
          <div class="dropdown" v-show="showTable" style="top: 44px;">
            <ul class="dropdown-content">
              <li class="menu-item" :class="tablesIndex == index ? 'selected' : ''" @click="titleChange(item.value,index)" v-for="(item, index) in urlData" :key="index">{{ item.name }}</li>
              <div class="arrow"></div>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- 个人信息 -->
    <Perpson ref="Perpson" :visibleRole="visibleRoles" @closes="closeModal"> </Perpson>
    <editPhone ref="editPhone" :visiblePhone="visiblePhone" @closes="closePhone"> </editPhone>
    <editPassDialog ref="editPassDialog" :visiblePass="visiblePass" @closes="closePass"></editPassDialog>
    <!-- 修改手机号 -->
    <!-- @close="handleClose(1)" -->
    <el-dialog :visible="visible" append-to-body width="80%" :show-close="true" @close="resetForm('ruleForm')">
      <div class="problem-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="问题反馈" name="first">

            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-form-item label="账号">
                <el-input v-model="ruleForm.userId" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="姓名">
                <el-input v-model="ruleForm.name" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="联系电话">
                <el-input v-model="ruleForm.phone" :disabled="true"></el-input>
              </el-form-item>

              <el-form-item label="问题描述" prop="contents">
                <el-input type="textarea" v-model="ruleForm.contents" :rows="4" show-word-limit maxlength="200"></el-input>
              </el-form-item>

              <!--  -->
              <el-form-item label="附件">
                <el-upload class="upload-demo" accept="image/jpeg, image/png,image/jpg" :action="actionUrl" :headers="uploadHeader" :on-success="cardImgAvatarSuccess" :before-upload="cardImgBeforeAvatarUpload" :show-file-list="false">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">注：支持上传JPG、PNG图片，大小不超过5M，最多3张</div>
                </el-upload>
                <div>
                  <div class="image-files" v-for="(item, index) in ruleForm.pictures" :key="index">
                    <el-image style="width: 100px; height: 100px" :src="item.url" :preview-src-list="ruleForm.pictures.map(pic => pic.url)">
                    </el-image>
                  </div>

                </div>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
                <el-button @click="resetForm('ruleForm')">取消</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="历史问题" name="second">
            <div class="setList margins8">
              <el-table :data="posalList" style="width: 100%" tooltip-effect=“dark”>
                <el-table-column type="index" label="序号" width="80">
                </el-table-column>
                <el-table-column prop="contents" label="问题描述" show-overflow-tooltip>
                </el-table-column>

                <el-table-column prop="status" label="状态">
                  <template slot-scope="scope">
                    <p class="contribution">{{ statusType[scope.row.status] }}</p>
                  </template>
                </el-table-column>

                <el-table-column prop="createTime" label="提交时间">
                  <template slot-scope="scope">
                    <p class="contribution">{{ scope.row.createTime | analyseTime('4') }}</p>

                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100">
                  <template slot-scope="scope">
                    <span class="set-btn" @click="goDetail(scope.row)">查看</span>
                  </template>
                </el-table-column>
              </el-table>
              <div class="page-apply">
                <Paging :totalNumber="zongtiaoshu" :pageShowTotal="pageSize" :showActivePageIndex="pageNum" @callBack="handleCurrentChange"></Paging>
              </div>
            </div>

          </el-tab-pane>

        </el-tabs>
      </div>
    </el-dialog>

    <el-dialog append-to-body :visible="visibleDetail" width="60%" @close="visibleDetail= false">
      <div class="problem-wrap" v-if="detailInfo != ''">
        <el-form ref="visibleDetail" label-width="100px" class="demo-ruleForm">
          <el-form-item label="反馈人">
            <div>{{detailInfo.submitterName}}</div>
          </el-form-item>

          <el-form-item label="联系电话">
            <div>{{detailInfo.userPhone}}</div>
          </el-form-item>
          <el-form-item label="反馈内容">
            <div>{{detailInfo.contents}}</div>
          </el-form-item>

          <el-form-item label="附件">
            <div class="image-files" v-for="(item, index) in detailInfo.pictures" :key="index">
              <el-image style="width: 100px; height: 100px" :src="item.url" :preview-src-list="detailInfo.pictures.map(pic => pic.url)">
              </el-image>
            </div>

          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import { insertProPosal, searchProposalList, searchProPosalDTOById } from './../../../api/api.p'
import Paging from './../page-comn/Paging.vue';
import Perpson from './../views/home/perpson.vue';
import editPhone from './../views/editPhone/editPhone.vue'
import editPassDialog from './../views/editPass/editPassDialog.vue'
export default {
  components: {
    Paging,
    Perpson,
    editPhone,
    editPassDialog
  },
  props: {
    pages: {
      type: String,
      default: ''
    },
    param: {
      type: String,
      default: ''
    },
    isRouterIndex: {
      type: String,
      default: ''
    },
  },
  data () {
    var banerIcon = (rule, value, callback) => {
      // 图片验证
      if (this.fileUrl == '') {
        callback(new Error("请上传封面图"));
      } else {
        callback();
      }
    };

    return {
      input: '',


      isScrolled: false, // 新增：标记是否已滚动超过 100px
      visibleRoles: false,
      visiblePhone: false,
      visiblePass: false,

      actionUrl: vocationalVal.thost + '/fdfsapi/fastdfs/uploadMuiltipart',
      uploadHeader: {
        token: localStorage.getItem('userUnifyToken'),
        kyWebInfo: 'channel/unify'
      },

      visibleDetail: false,
      detailInfo: '',
      activeName: 'first',
      ruleForm: {
        name: '',
        userId: '',
        phone: '',

        contents: '',
        pictures: []

      },
      rules: {

        contents: [
          { required: true, message: '请填写问题描述', trigger: 'blur' }
        ],
        pictures: [
          { required: true, validator: banerIcon, trigger: "change" }
        ],

      },

      showTable: false,
      showTableWen: false,

      selectUrl: 'home',
      urlDataWen: [
        {
          name: '问题反馈',
          value: 'feedback'
        },
        {
          name: '常见问题',
          value: 'serviceList'
        },
      ],
      tablesIndexWen: 0,

      urlData: [
        // {
        //   name: '首页',
        //   value: 'home'
        // },
        {
          name: '个人信息',
          value: 'perpson'
        },
        // {
        //   name: '修改手机号',
        //   value: 'editPhone'
        // },
        {
          name: '修改密码',
          value: 'editPass'
        },
        {
          name: '退出登录',
          value: 'loginout'
        },
      ],
      tablesIndex: 0,
      userInfo: '',
      visible: false,
      pageNum: 1,
      pageSize: 10,
      zongtiaoshu: 0,
      posalList: [],
      statusType: {
        0: '未读',
        1: '已读'
      }
    }
  },
  created () {
    window.scrollTo(0, 0); // 新增
    if (localStorage.getItem('userUnifyInfo')) {
      this.userInfo = JSON.parse(localStorage.getItem('userUnifyInfo'))

    }
    this.selectUrl = this.$route.name;
  },
  mounted () {
    // 添加滚动事件监听
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy () {
    // 移除滚动事件监听（避免内存泄漏）
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    goNewList () {
      window.open('https://www.mxzy.edu.cn')
    },
    search () {
      if (this.pages == 'notice' || this.pages == 'search') {
        console.log(this.pages, 'pages')
        this.$emit('childEvent', this.input);
      } else if (this.pages == 'home') {
        console.log(this.pages)
        this.$emit('homeBtn', this.input);
      }

    },

    // 新增：处理滚动事件
    handleScroll () {
      this.isScrolled = window.scrollY > 100; // 检测是否滚动超过 100px
    },
    closeModal () {
      this.visibleRoles = false; // 关闭弹窗
    },
    closePhone () {
      this.visiblePhone = false; // 关闭弹窗
    },
    closePass () {
      this.visiblePass = false; // 关闭弹窗
    },
    //searchProPosalDTOById 
    async goDetail (item) {
      this.detailInfo = '';

      let params = {
        "id": item.id
      }
      const res = await searchProPosalDTOById(params);
      if (res) {

        if (res.meta.code == 0) {
          this.visibleDetail = true;
          this.detailInfo = res.data;

        } else {
          this.$toast(res.meta.message);
        }

      } else {

        this.$toast('操作失败');
      }

    },

    init () {
      if (localStorage.getItem('userUnifyInfo')) {
        this.userInfo = JSON.parse(localStorage.getItem('userUnifyInfo'))

      }
      if (this.pages == 'search') {
        console.log(this.pages)
        this.input = this.param;
      }
      // console.log(JSON.parse(sessionStorage.getItem('userUnifyInfo')), 'userUnifyInfo1', localStorage.getItem('userUnifyInfo'))
      // this.getMyUserInfo()
    },
    // 个人信息
    getMyUserInfo () {
      getMyUserInfo()
        .then((res) => {
          if (res.meta.code == 0) {
            this.userInfo = res.data
          } else {
            this.$toast(res.meta.message)
          }
        })
        .catch((err) => {
          this.$toast(err.meta.message)
        })
    },
    handleCurrentChange (val, index) {
      this.pageNum = val;
      this.pageSize = index;
      this.searchProposalList();
    },
    proBtn () {
      this.visible = true;
      this.activeName = 'first';
      this.ruleForm.contents = ''
      this.ruleForm.pictures = []
      this.ruleForm.name = this.userInfo.userName;
      this.ruleForm.phone = this.userInfo.phone;
      this.ruleForm.userId = this.userInfo.userId;

      this.zongtiaoshu = 0;
      this.pageNum = 1;
      this.pageSize = 10;
      this.posalList = [];

    },
    cardImgAvatarSuccess (response, file, fileList) {
      if (response.meta.code == 0) {
        let info = {
          url: response.data.fileUrl,
          imgHW: ''
        }
        this.ruleForm.pictures.push(info);
      }

    },
    cardImgBeforeAvatarUpload (file) {
      console.log(file, '----')

      let _this = this;
      const is1M = file.size / 1024 / 1024 < 10; // 限制小于1M
      const isJPG = file.type === "image/jpg";
      const isPNG = file.type === "image/png";
      const isJPEG = file.type === "image/jpeg";
      if (!isJPG && !isPNG && !isJPEG) {
        _this.$toast("上传文件支持png、jpeg、jpg格式!");
        return;
      }
      if (!is1M) {
        _this.$toast("文件限制 10M 以内");
        return false;
      }
      return (isJPG || isPNG || isJPEG) & is1M;// && isSize;
    },

    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.insertProPosal(formName)
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async insertProPosal (formName) {

      let params = {
        "contents": this.ruleForm.contents,
        "pictures": this.ruleForm.pictures,
        "userPhone": this.ruleForm.phone
      }
      const res = await insertProPosal(params);
      if (res) {

        if (res.meta.code == 0) {
          this.$refs[formName].resetFields();
          this.visible = false;

        } else {
          this.$toast(res.meta.message);
        }

      } else {

        this.$toast('操作失败');
      }

    },


    resetForm (formName) {
      this.$refs[formName].resetFields();
      this.visible = false;
    },

    handleClick (tab, event) {

      if (this.activeName == 'second') {
        console.log(tab, '333', this.activeName);
        this.searchProposalList()
      } else {
        this.zongtiaoshu = 0;
        this.pageNum = 1;
        this.pageSize = 10;
        this.posalList = [];

      }
    },
    async searchProposalList () {

      let params = {
        "pageNumber": this.pageNum,
        "numPerPage": this.pageSize,
      }
      const res = await searchProposalList(params);
      if (res) {

        if (res.meta.code == 0) {
          this.posalList = res.data.records;

          this.zongtiaoshu = JSON.parse(res.data.total);

        } else {
          this.$toast(res.meta.message);
        }

      } else {

        this.$toast('操作失败');
      }

    },

    goHome () {
      this.showTableWen = false;
      this.showTable = !this.showTable;
    },
    goHomeWen () {
      this.showTable = false;
      this.showTableWen = !this.showTableWen;
    },
    titleChangeWen (val, index) {
      console.log(val)

      this.tablesIndexWen = index;
      this.showTableWen = false;
      if (val == 'serviceList') {
        this.$router.push({
          name: val,
          query: { push: true, indexs: 4 }
        });
      } else if (val == 'feedback') {
        this.proBtn()
      }


    },
    goHomes () {
      this.$router.push({
        name: 'home',
        query: { push: true }
      });
    },
    titleChange (val, index) {
      console.log(index)

      this.tablesIndex = index;
      this.showTable = false;
      // return
      if (val.indexOf("http") > -1) {
        window.location.href = val + '?push=true';
      } else {
        if (val == 'home' || val == 'loginout') {
          this.$router.push({
            name: val,
            query: { push: true }
          });
        } else if (val == 'perpson') {
          console.log(val, '00000')
          this.visibleRoles = true;
          this.$refs.Perpson.init()
        } else if (val == 'editPhone') {
          this.visiblePhone = true;
          this.$refs.editPhone.init()
        } else if (val == 'editPass') {
          this.visiblePass = true;
          this.$refs.editPassDialog.init()
        }


      }
    },
  }
}
</script>
<style lang="less" scoped>
.another-class {
  background: #1e4fa1;
}
/*
todo table 公共样式
*/
::v-deep.setList .el-table td,
::v-deep.setList .el-table th.is-leaf {
  border: none !important;
}

::v-deep.setList .el-table::before {
  display: none;
}

::v-deep.setList .el-table thead {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400 !important;
  color: #202020;
}

::v-deep.setList .el-table thead tr {
  background: #f8f8fa !important;
  border-radius: 4px;
}

::v-deep.setList .el-table thead tr .is-leaf {
  background: #f8f8fa !important;
}

::v-deep.setList .el-table td,
::v-deep.setList .el-table th {
  padding: 14px 0 !important;
  font-weight: 400;
}

::v-deep.setList .el-table__body {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}

::v-deep.setList .el-table th > .cell,
::v-deep.setList .el-table .cell {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

::v-deep.setList .set-btn {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #486fff;
  cursor: pointer;
  margin-right: 8px;
}

::v-deep.setList .set-btn:last-child {
  margin-right: 0 !important;
}

::v-deep.setList .el-table--border,
::v-deep.setList .el-table--group {
  border: 1px solid transparent !important;
}

::v-deep.setList .el-table--border::after,
::v-deep.setList .el-table--group::after {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
}

::v-deep.setList .el-table__row:nth-child(2n) {
  background: #f8f8fa !important;
  border-radius: 4px;
}

::v-deep.setList .el-table__row:nth-child(2n) .is-center {
  background: #f8f8fa !important;
}

::v-deep.setList .el-table__row:nth-child(2n-1) {
  background: #fff !important;
  border-radius: 4px;
}

::v-deep.setList .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: transparent !important;
}

::v-deep.problem-wrap {
  .el-tabs__nav-wrap::after {
    display: none !important;
  }
}

.dropdown {
  position: absolute;
  top: 30px;
  right: -15px;

  .dropdown-content {
    width: 110px;
    border-radius: 4px;
    background-color: #fff;
    padding: 6px 0;
    .menu-item {
      font-size: 14px;
      padding: 0 20px;
      color: #606266;
      height: 34px;
      line-height: 34px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      cursor: pointer;
      text-align: center;
    }
    .menu-item:hover {
      background-color: #f5f7fa;
    }
  }
}
.arrow {
  position: absolute;
  top: -8px;
  left: 40%;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #fff;
}
.selected {
  color: #4086f6 !important;
}
.scrolled {
  background: rgba(30, 79, 161, 0.8) !important;
}
/*顶部导航*/
::v-deep.home-head {
  width: 100%;
  height: 80px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;

  .home-header {
    width: calc(100vw - 200px);
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    height: 80px;
    align-items: center;
    // min-width: 1000px;
    // max-width: 1580px;
    .home-header__logo {
      width: 268px;
      height: 56px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .home-header__quick {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: right;

      .home-header__quick__search {
        width: 274px;
        height: 36px;
        background: #ffffff;
        border-radius: 18px;
        position: relative;
        margin-right: 8px;

        input {
          border: 0;
          width: 100%;
          height: 36px;
          border-radius: 18px;
          padding-left: 10px;
          &::placeholder {
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: 400;
            font-size: 14px;
            color: #1e4fa1;
            padding-left: 24px;
          }
        }
        .home-header__quick__search__icon {
          width: 16px;
          height: 16px;
          position: absolute;
          right: 16px;
          top: 50%;
          transform: translateY(-50%);
        }
      }

      .home-header__quick__nav {
        display: flex;

        .home-header__quick__nav__item {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 14px;
          cursor: pointer;
          img {
            width: 16px;
            height: 16px;
          }
          span {
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
            margin-left: 8px;
          }
        }
      }

      .home-header__quick__user {
        display: flex;
        margin-left: 31px;
        align-items: center;
        .home-header__quick__user__avatar {
          width: 32px;
          height: 32px;
          margin-right: 9px;
          border-radius: 50%;
        }
        .home-header__quick__user__name {
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          margin-right: 8px;
        }
        .home-header__quick__user__arrow {
          width: 8px;
          height: 5px;
          cursor: pointer;
        }
      }
    }
  }
}
::v-deep.image-files {
  width: 100px;
  height: 100px;
  margin-right: 8px;
  display: inline-block;
}
.homes-btns {
  font-family: SourceHanSansCN, SourceHanSansCN;
  font-weight: 400;
  font-size: 14px;
  color: #1e232a;
  line-height: 21px;
  text-align: left;
  font-style: normal;
  margin-right: 14px;
  cursor: pointer;
}
</style>
